import {lastValueFrom, Observable} from 'rxjs'

export async function drain(observable: Observable<unknown>) {
    await lastValueFrom(observable, {defaultValue: null})
}
